/**
 * MapWorkspaceSelectHint — floating callout guiding the user to the
 * WorkspaceSwitcher in the navbar when workspaces exist but none is active.
 * Sits under the search column like {@link MapWorkspaceEmptyLocations}: the two
 * are mutually exclusive states of the same slot.
 */
import { cn } from '@/libs/utils/cn';
import { MapCallout } from './MapCallout';
import {
  MAP_BESIDE_CARD_LEFT_CLASS,
  MAP_INFO_CARD_CLASS,
  MAP_LAYER_PANEL_WIDTH_CLASS,
} from './mapBarGeometry';
import { MAP_PANEL_SURFACE } from './mapPanelSurface';

interface MapWorkspaceSelectHintProps {
  /** A zone, deal, location or place card holds the slot: the hint moves beside it. */
  besideCard?: boolean;
}

export function MapWorkspaceSelectHint({ besideCard = false }: MapWorkspaceSelectHintProps) {
  return (
    <div
      role="note"
      data-testid="workspace-select-hint"
      className={cn(
        MAP_INFO_CARD_CLASS,
        MAP_LAYER_PANEL_WIDTH_CLASS,
        'z-20 rounded-[10px] p-4',
        MAP_PANEL_SURFACE,
        besideCard && MAP_BESIDE_CARD_LEFT_CLASS,
      )}
    >
      <MapCallout
        title="No workspace selected"
        icon={
          <svg viewBox="0 0 16 16" fill="none" className="size-4" aria-hidden="true">
            <path
              d="M2 4.5A1.5 1.5 0 0 1 3.5 3h2.6l1.2 1.5h5.2A1.5 1.5 0 0 1 14 6v6a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 12V4.5Z"
              stroke="currentColor"
              strokeWidth="1.3"
              strokeLinejoin="round"
            />
          </svg>
        }
      >
        Click <b className="font-bold text-[#0b2936]">Choose a workspace</b> above to start adding
        locations.
      </MapCallout>
    </div>
  );
}
